import styled from '@emotion/styled'

interface SvgItemProps {
  animation?: string
  transition?: string
  transform?: string
  transformOrigin?: string
}

export const Svg = styled('svg')<SvgItemProps>(
  ({ focusable = 'false', ...props }) => ({
    animation: props.animation,
    transition: props.transition,
    transform: props.transform,
    transformOrigin: props.transformOrigin,
  }),
)

Svg.displayName = 'Svg'

const SvgItem = (tag: keyof JSX.IntrinsicElements) =>
  styled(tag)<SvgItemProps>((props) => ({
    animation: props.animation,
    transition: props.transition,
    transform: props.transform,
    transformOrigin: props.transformOrigin,
  }))

export const Path = SvgItem('path')

Path.displayName = 'Path'

export const Rect = SvgItem('rect')

Rect.displayName = 'Rect'

export const Circle = SvgItem('circle')

Circle.displayName = 'Circle'
